export default __webpack_public_path__ + "fad5b09bd0016ccb5efa2aa1e4fe1f3b.jpg";